export enum CoinflowProductType {
  IN_GAME_PRODUCT = 'inGameProduct',
  GAME_OF_SKILL = 'gameOfSkill',
  COMPUTING_RESOURCES = 'computingResources',
  SPORTS_TICKET = 'sportsTicket',
  ESPORTS_TICKET = 'eSportsTicket',
  MUSIC_TICKET = 'musicTicket',
  CONFERENCE_TICKET = 'conferenceTicket',
  VIRTUAL_SPORTS_TICKET = 'virtualSportsTicket',
  VIRTUAL_ESPORTS_TICKET = 'virtualESportsTicket',
  VIRTUAL_MUSIC_TICKET = 'virtualMusicTicket',
  VIRTIAL_CONFERENCE_TICKET = 'virtualConferenceTicket',
  ALCOHOL = 'alcohol',
  DLC = 'DLC',
  SUBSCRIPTION = 'subscription',
  FUND_A_CAUSE = 'fundACause',
  REAL_ESTATE = 'realEstate',
  COMPUTING_CONTRACT = 'computingContract',
  DIGITAL_ART = 'digitalArt',
  TOP_UP = 'topUp',
}
